import * as React from 'react';
import { Row, Col, FormControl, FormGroup, ControlLabel, Checkbox } from 'react-bootstrap';
import { Translate } from '../../../shared/LanguageService';
import FormSelect from '../../../components/common/FormSelect';
import * as Features from '../../../shared/Features';
import ISe360User from '../../se360users/ISe360User';

interface IStatisticsFilter {
    numberOfOrders: boolean;
    totalIncome: boolean;
    totalPhotographerCost: boolean;
    totalExternalCost: boolean;
    amountInOut: boolean;
    hideUnusedProducts: boolean;
    showNumberOfUniqueProducts: boolean;
    numberOfPhotoOrders: boolean;
    numberOfPhotoSubOrders: boolean;
    numberOfImages: boolean;
    numberOfBookDirectOrders: boolean;
    customerDirectOrders: boolean;
    numberOfPlanOrders: boolean;
    numberOfUploadedPlanOrders: boolean;
    numberOfPlanStoreys: boolean;
    numberOfRoomSketcherPlanStoreys: boolean;
    numberOfSketchupPlanStoreys: boolean;
    groupedProducts: {
        id: string;
        name: string;
        products: { id: string; name: string }[];
    }[];
    selectedProducts: string[];
    productGroups: { id: number; name: string }[];
    selectedProductGroup?: number;
    user: ISe360User;
    onProductGroupChanged(e: any): void;
    handleMultiselectChange(e: any);
    handleCheckboxChange(e: any);
}

const StatisticsSelection = (props: IStatisticsFilter) => {
    return (
        <fieldset>
            <legend>{Translate('statistics/page/fieldset/selection/legend')}</legend>
            <Row>
                <Col md={4}>
                    <Checkbox
                        name="selections.numberOfOrders"
                        checked={props.numberOfOrders}
                        onChange={props.handleCheckboxChange}
                    >
                        <span>
                            {Translate('statistics/page/fieldset/selection/number-of-orders/label')}
                        </span>
                    </Checkbox>
                    {Features.hasFeature(Features.ViewEconomicStatistics, props.user) && (
                        <Checkbox
                            name="selections.totalIncome"
                            checked={props.totalIncome}
                            onChange={props.handleCheckboxChange}
                        >
                            <span>
                                {Translate('statistics/page/fieldset/selection/total-income/label')}
                            </span>
                        </Checkbox>
                    )}
                    {Features.hasFeature(Features.ViewEconomicStatistics, props.user) && (
                        <Checkbox
                            name="selections.totalPhotographerCost"
                            checked={props.totalPhotographerCost}
                            onChange={props.handleCheckboxChange}
                        >
                            <span>
                                {Translate(
                                    'statistics/page/fieldset/selection/total-photographer-cost/label'
                                )}
                            </span>
                        </Checkbox>
                    )}
                    {Features.hasFeature(Features.ViewEconomicStatistics, props.user) && (
                        <Checkbox
                            name="selections.totalExternalCost"
                            checked={props.totalExternalCost}
                            onChange={props.handleCheckboxChange}
                        >
                            <span>
                                {Translate(
                                    'statistics/page/fieldset/selection/total-external-cost/label'
                                )}
                            </span>
                        </Checkbox>
                    )}
                    {Features.hasFeature(Features.ViewEconomicStatistics, props.user) && (
                        <Checkbox
                            name="selections.amountInOut"
                            checked={props.amountInOut}
                            onChange={props.handleCheckboxChange}
                        >
                            <span>
                                {Translate(
                                    'statistics/page/fieldset/selection/amount-in-out/label'
                                )}
                            </span>
                        </Checkbox>
                    )}
                    <Checkbox
                        name="selections.hideUnusedProducts"
                        checked={props.hideUnusedProducts}
                        onChange={props.handleCheckboxChange}
                    >
                        <span>
                            {Translate(
                                'statistics/page/fieldset/selection/hide-unused-products/label'
                            )}
                        </span>
                    </Checkbox>
                    <Checkbox
                        name="selections.showNumberOfUniqueProducts"
                        checked={props.showNumberOfUniqueProducts}
                        onChange={props.handleCheckboxChange}
                    >
                        <span>
                            {Translate(
                                'statistics/page/fieldset/selection/show-number-of-unique-products/label'
                            )}
                        </span>
                    </Checkbox>
                    <Checkbox
                        name="selections.numberOfPhotoOrders"
                        checked={props.numberOfPhotoOrders}
                        onChange={props.handleCheckboxChange}
                    >
                        <span>
                            {Translate(
                                'statistics/page/fieldset/selection/number-of-photo-orders/label'
                            )}
                        </span>
                    </Checkbox>
                    <Checkbox
                        name="selections.numberOfPhotoSubOrders"
                        checked={props.numberOfPhotoSubOrders}
                        onChange={props.handleCheckboxChange}
                    >
                        <span>
                            {Translate(
                                'statistics/page/fieldset/selection/number-of-sub-orders/label'
                            )}
                        </span>
                    </Checkbox>
                    <Checkbox
                        name="selections.numberOfImages"
                        checked={props.numberOfImages}
                        onChange={props.handleCheckboxChange}
                    >
                        <span>
                            {Translate('statistics/page/fieldset/selection/number-of-images/label')}
                        </span>
                    </Checkbox>
                </Col>
                <Col md={4}>
                    <Checkbox
                        name="selections.customerDirectOrders"
                        checked={props.customerDirectOrders}
                        onChange={props.handleCheckboxChange}
                    >
                        <span>
                            {Translate(
                                'statistics/page/fieldset/selection/customer-direct-orders/label'
                            )}
                        </span>
                    </Checkbox>
                    <Checkbox
                        name="selections.numberOfBookDirectOrders"
                        checked={props.numberOfBookDirectOrders}
                        onChange={props.handleCheckboxChange}
                    >
                        <span>
                            {Translate(
                                'statistics/page/fieldset/selection/number-of-book-direct-orders/label'
                            )}
                        </span>
                    </Checkbox>
                    <Checkbox
                        name="selections.numberOfPlanOrders"
                        checked={props.numberOfPlanOrders}
                        onChange={props.handleCheckboxChange}
                    >
                        <span>
                            {Translate(
                                'statistics/page/fieldset/selection/number-of-plan-orders/label'
                            )}
                        </span>
                    </Checkbox>
                    <Checkbox
                        name="selections.numberOfUploadedPlanOrders"
                        checked={props.numberOfUploadedPlanOrders}
                        onChange={props.handleCheckboxChange}
                    >
                        <span>
                            {Translate(
                                'statistics/page/fieldset/selection/number-of-uploaded-plans/label'
                            )}
                        </span>
                    </Checkbox>
                    <Checkbox
                        name="selections.numberOfPlanStoreys"
                        checked={props.numberOfPlanStoreys}
                        onChange={props.handleCheckboxChange}
                    >
                        <span>
                            {Translate(
                                'statistics/page/fieldset/selection/number-of-plan-storeys/label'
                            )}
                        </span>
                    </Checkbox>
                    <Checkbox
                        name="selections.numberOfRoomSketcherPlanStoreys"
                        checked={props.numberOfRoomSketcherPlanStoreys}
                        onChange={props.handleCheckboxChange}
                    >
                        <span>
                            {Translate(
                                'statistics/page/fieldset/selection/number-of-roomsketcher-plan-storeys/label'
                            )}
                        </span>
                    </Checkbox>
                    <Checkbox
                        name="selections.numberOfSketchupPlanStoreys"
                        checked={props.numberOfSketchupPlanStoreys}
                        onChange={props.handleCheckboxChange}
                    >
                        <span>
                            {Translate(
                                'statistics/page/fieldset/selection/number-of-sketchup-plan-storeys/label'
                            )}
                        </span>
                    </Checkbox>
                </Col>
                <Col md={4}>
                    <FormGroup>
                        <ControlLabel>
                            {Translate('statistics/page/fieldset/selection/product-groups/label')}
                        </ControlLabel>
                        <FormSelect
                            name="selections.selectedProductGroup"
                            value={
                                props.selectedProductGroup
                                    ? props.selectedProductGroup.toString()
                                    : ''
                            }
                            onChange={props.onProductGroupChanged}
                        >
                            <option value="">
                                {Translate(
                                    'statistics/page/fieldset/selection/product-groups/default'
                                )}
                            </option>
                            {props.productGroups.map((x, i) => {
                                return (
                                    <option key={'product-group-' + i} value={x.id.toString()}>
                                        {x.name}
                                    </option>
                                );
                            })}
                        </FormSelect>
                    </FormGroup>
                    <FormGroup>
                        <ControlLabel>
                            {Translate('statistics/page/fieldset/selection/products/label')}
                        </ControlLabel>
                        <FormControl
                            name="selections.selectedProducts"
                            componentClass="select"
                            className="height-11-em"
                            value={props.selectedProducts}
                            multiple
                            onChange={(e) => props.handleMultiselectChange(e)}
                        >
                            {props.groupedProducts.map((g, gIndex) => {
                                return <optgroup key={'group-' + gIndex} label={g.name}>
                                    {g.products.map((p, pIndex) => (
                                        <option key={'product-' + pIndex} value={p.id}>
                                            {p.name}
                                        </option>
                                    ))}
                                </optgroup>
                            })}
                        </FormControl>
                    </FormGroup>
                </Col>
            </Row>
        </fieldset>
    );
};

export default StatisticsSelection;
